import { Checkbox, Stack, Typography, useTheme } from '@mui/material';
import { useForm } from 'react-hook-form';

import { FormProvider, GlassEffectDialog } from '@app/components';
import { IAddTaskBoardSchema } from '../types';
import { selectBoardDetailsState } from '../selector';
import { useRequestState } from '@app/hooks';
import { permissionsData } from '@app/mock/taskBoard';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  iconName: string;
}

const PermissionDialog = ({ open, onClose, iconName }: Props) => {
  const methods = useForm<IAddTaskBoardSchema>();
  const theme = useTheme();

  const { data } = useRequestState({
    stateSelector: selectBoardDetailsState,
    errorShown: true,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <GlassEffectDialog
          open={open}
          onClose={onClose}
          title={'Permissions'}
          backgroundImage={data?.image}
          boardIcon={iconName}
        >
          <Stack sx={{ width: '340px', px: 2 }} gap={1.5}>
            {permissionsData.map((permission: any, index: number) => {
              return (
                <Stack key={index} sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Checkbox
                    sx={{
                      '&.Mui-checked': {
                        color: theme.palette.taskboard.raisinBlack,
                      },
                    }}
                  />
                  <Stack ml={1.5} spacing={-0.5}>
                    <Typography sx={{ fontWeight: 600 }}>{permission?.title}</Typography>
                    <Typography sx={{ fontSize: '10px', fontWeight: 500 }}>
                      {permission?.description}
                    </Typography>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        </GlassEffectDialog>
      </FormProvider>
    </>
  );
};

export { PermissionDialog };
